// new global object
import React from "react";
import store from "../store";
import Cookies from "universal-cookie";
import Routes from '../Routes';

// functions
import getDomEl from "../functions/getDomEl";
import logoutUser from '../functions/logoutUser';
import getModuleLoginPage from '../functions/getModuleLoginPage';
import isObjectEmpty from '../functions/isObjectEmpty';

const GLOBALS = {
  cookies: new Cookies(),
  setCookie: (prop, val) => GLOBALS.cookies.set(prop, val, { path: '/' }),
  getCookie: (val) => GLOBALS.cookies.get(val),
  removeCookie: (val) => GLOBALS.cookies.remove(val, { path: "/" }),
  authCookie: () => GLOBALS.cookies.get('auth'),
  reduxStore: store,
  screenSizeChangedFor: 0,

  getDomEl: getDomEl,
  logoutUser: logoutUser,
  getModuleLoginPage: getModuleLoginPage,
  isObjectEmpty: isObjectEmpty
};

export default GLOBALS;
